Ext.define('PanelMobileObjectPreview', {
    extend: 'Ext.panel.Panel',
    xtype: 'panelmobileobjectpreview',
    alias: 'widget.panelmobileobjectpreview',
    cls: 'a-PanelMobileObjectPreview',
    id: 'panelmobileobjectpreview',
    layout: 'auto',
    scrollable: false,
    items : [{
        xtype: 'container',
        itemId: 'mapPanel',
        layout: {
            type: 'table',
            columns: 1
        },
        cls: 'custom-mobile-preview-panel-cls',
    }],
    loadData: function(mapData) {
        var panel = this.down('#mapPanel');
        panel.removeAll();
        let iteration = 0
        Ext.Object.each(mapData, function (key, value) {
            iteration++;
            let oddOrEvenClass = (iteration % 2 === 0) ? 'even-row' : 'odd-row';
            panel.add({
                xtype: 'container',
                layout: 'hbox',
                cls: oddOrEvenClass,
                items: [{
                    xtype: 'label',
                    html: key,
                    cls: 'key-label',
                    flex: 1
                }, {
                    xtype: 'label',
                    html: value,
                    cls: 'value-label',
                    flex: 1
                }]
            });
        });
    }
});